import * as Yup from "yup";
import { ApplicantDetailsState } from "./ApplicantDetailsFold";
import { regexList } from "../../../Constants";
import moment from "moment";

export const applicantDetailsFoldConstants = {
  labels: {
    firstName: "First Name",
    middleName: "Middle Name",
    lastName: "Last Name",
    panNumber: "PAN Number",
    dateOfBirth: "Date of Birth",
    currentAddress: "Current Residence Address",
    currentAddressType: "Residence Property Type",
    currentAddressState: "Residence state",
    currnentAddressPincode: "PIN Code",
    PermanentAddress: "Permanent  Address",
    PermanentAddressType: "Address Property Type",
    permanentAddressState: "State",
    PermanentAddressPincode: "PIN Code",
    addressSame: "Permanent address same as current address?",
    dateFormat: "DD-MM-YYYY",
    addressNotSameNote: "If No, provide details below",
    city: "Residence City",
    residenceStability: "Residence Stability (in months)",
    permanentAddressCity: "Permanent City"
  },
  buttons: {
    next: "Next"
  }
};

//options for radio button
export const booleanOptions = {
  Yes: true,
  No: false
};

export const regex = {
  panNo: new RegExp("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")
};

const errorMessages = {
  required: "Required",
  invalidFormat: "Invalid Format",
  underAge: "Age should be minimum 18 years"
};

export const applicantDetailsFoldValidationSchema = Yup.object().shape<
  Partial<ApplicantDetailsState>
>({
  firstName: Yup.string()
    .required(errorMessages.required)
    .nullable()
    .matches(regexList.minimum1Character, errorMessages.invalidFormat),
  middleName: Yup.string()
    .nullable()
    .matches(regexList.minimum1Character, errorMessages.invalidFormat),
  lastName: Yup.string()
    .required(errorMessages.required)
    .nullable()
    .matches(regexList.minimum1Character, errorMessages.invalidFormat),
  panNumber: Yup.string()
    .required(errorMessages.required)
    .matches(regex.panNo, errorMessages.invalidFormat)
    .nullable(),
  currentAddress: Yup.string()
    .required(errorMessages.required)
    .nullable()
    .matches(regexList.minimum1Character, errorMessages.invalidFormat),
  currentAddressType: Yup.string()
    .required(errorMessages.required)
    .nullable(),
  currentAddressPincode: Yup.string()
    .required(errorMessages.required)
    .nullable(),
  currentAddressState: Yup.string()
    .required(errorMessages.required)
    .nullable(),
  residenceStability: Yup.number()
    .required(errorMessages.required)
    .nullable(),
  dateOfBirth: Yup.string()
    .required(errorMessages.required)
    .test({
      name: "Below 18 check",
      test(value) {
        return Math.floor(
          moment(new Date()).diff(
            moment(value, applicantDetailsFoldConstants.labels.dateFormat),
            "years",
            true
          )
        ) < 18
          ? this.createError({
              message: errorMessages.underAge
            })
          : true;
      }
    })
    .nullable(),
  permanentAddress: Yup.string()
    .nullable()
    .when("isPermanentAddressSameAsCurrentAddress", {
      is: false,
      then: Yup.string()
        .required(errorMessages.required)
        .nullable()
        .matches(regexList.minimum1Character, errorMessages.invalidFormat)
    }),
  permanentAddressType: Yup.string()
    .nullable()
    .when("isPermanentAddressSameAsCurrentAddress", {
      is: false,
      then: Yup.string()
        .required(errorMessages.required)
        .nullable()
    }),
  permanentAddressPincode: Yup.string()
    .nullable()
    .when("isPermanentAddressSameAsCurrentAddress", {
      is: false,
      then: Yup.string()
        .required(errorMessages.required)
        .nullable()
    }),
  permanentAddressState: Yup.string()
    .nullable()
    .when("isPermanentAddressSameAsCurrentAddress", {
      is: false,
      then: Yup.string()
        .required(errorMessages.required)
        .nullable()
    })
});
